import {
  buildGroupsCheckUniquenessListPath,
  buildGroupsExportListPath as buildGroupsExportListPathGenerated,
} from '../../generated/schooly-api-v1';

export const buildCheckGroupUniquenessPath = buildGroupsCheckUniquenessListPath;
export const buildGroupsExportPath = buildGroupsExportListPathGenerated;
